import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import RoutesPath from "./Routes";
import Mainindex from "./components/Layout/Main";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import {
  setAllEntityList,
  setConsigneeList,
  setConsignerList,
  setCountryList,
  setDriverList,
  setDriverWithVehicle,
  setKpiNameList,
  setLatLongList,
  setRespientList,
  setRoleList,
  setSupllierList,
  setTransporterList,
  setUserInfo,
  setUserList,
  setVehicleList,
  setVehicleType,
  ssetOfficeList,
  setSmsTemplate,
  setUserPermissionList,
  setAICompanyList,
  setAIVehicleLists,
  setFenceList,
  setNexusFenceList,
  setMyPermissionList,
  setSubscriptionList,
} from "./Redux/AuthSlice";
import { CALL_API } from "./Common/api";
import LiveMapcomponent from "./containers/LiveTrack/LiveMapcomponent";
import styled from "styled-components";
import "bootstrap/dist/css/bootstrap.min.css";
import { ReactComponent as VideoIcon } from "../src/assets/images/Video.svg";
import { ReactComponent as Videoon } from "../src/assets/images/Video-On.svg";
import { ReactComponent as MovingVehicle } from "../src/assets/images/MovingVehicle.svg";
import { ReactComponent as LiveTrackFour } from "../src/assets/livetracking/livetrackfour.svg";
import { ReactComponent as StationaryVehicle } from "../src/assets/images/StationaryVehicle.svg";
import { Marker, Popup } from "react-map-gl";
import { ReactComponent as Info } from "../src/assets/images/Info.svg";
import { ReactComponent as Infoon } from "../src/assets/images/Info-On.svg";
import { ReactComponent as SignalIcon } from "../src/assets/images/Signals-2.svg";
import { ReactComponent as LiveTrackone } from "../src/assets/livetracking/livetrackone.svg";
import { ReactComponent as LockIcon } from "../src/assets/images/locked.svg";
import { ReactComponent as UnLockIcon } from "../src/assets/images/unlocked.svg";
import { ReactComponent as SpeedIcon } from "../src/assets/images/speed (2).svg";
import { ReactComponent as Batteryicon } from "../src/assets/images/gg_battery.svg";
import { ReactComponent as LowBatteryicon } from "../src/assets/images/low-bt.svg";
import { ReactComponent as PinIcon } from "../src/assets/livetracking/pinIcon.svg";
import { ReactComponent as PinIconone } from "../src/assets/livetracking/PinIconone.svg";
import { PopupProvider } from "./Reusablecomponents/Usepopup/PopupContext";
import DraggablePopup from "./components/Popup/DraggablePopup";
import { Button, Modal } from "antd";

// :white_tick: Convert AuthHandler into a custom hook

const Newbox = styled.div`
  .floating-card {
    position: absolute;
    width: 380px;
    background: #e9f8ef;
    border-radius: 14px;
    padding: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    z-index: 1000;
  }

  .drag-header {
    cursor: grab;
    user-select: none;
  }

  .drag-header:active {
    cursor: grabbing;
  }

  .details {
    font-size: 13px;
  }

  hr {
    margin: 8px 0;
  }
`;

function App() {
  // :white_tick: Use the custom hook inside App
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [sessionTimeout, setSessionTimeout] = useState(false);
  const [open, setOpen] = useState(false);

  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const floatingData = useSelector(
    (state) => state?.authTracking?.floatingModalData,
  );
  const fetchOfficeList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getoffice", {
      mcId: MCID,
    });
    dispatch(ssetOfficeList(data));
  };
  const fetchDriverList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getDriver", {
      mcId: MCID,
    });
    dispatch(setDriverList(data));
  };
  const fetchKpiNameList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getKPIName", {
      mcId: MCID,
    });
    dispatch(setKpiNameList(data));
  };
  const fetchRoleList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getRole", {
      mcId: MCID,
    });
    dispatch(setRoleList(data));
  };
  const fetchSupllierList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getSupplier", {
      mcId: MCID,
    });
    dispatch(setSupllierList(data));
  };
  const fetchCountryList = async () => {
    const { data } = await CALL_API("GET", "common/getAllCountries");
    dispatch(setCountryList(data));
  };
  const fetchConsignerList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 1,
    });
    dispatch(setConsignerList(data));
  };
  const fetchVehicleType = async (MCID) => {
    const { data } = await CALL_API("GET", "common/getVehicleType");
    dispatch(setVehicleType(data));
  };
  const fetchAllVehicleList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getAllRegNo", {
      mcId: MCID,
    });
    dispatch(setVehicleList(data));
  };
  const fetchTransporterList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 2,
    });
    dispatch(setTransporterList(data));
  };
  const fetchConsigneeList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 3,
    });
    dispatch(setConsigneeList(data));
  };
  const fetchRespientList = async (MCID) => {
    const { data } = await CALL_API("GET", `common/getRecpList?mcId=${MCID}`);
    dispatch(setRespientList(data));
  };
  const fetchDriverWithVehicle = async (MCID) => {
    const { data } = await CALL_API(
      "GET",
      `common/getVehicleWithDriver?mcid=${MCID}`,
    );
    dispatch(setDriverWithVehicle(data?.recordsets[0]));
  };
  const fetchAllEntityList = async (MCID) => {
    const { data } = await CALL_API("GET", `common/getEntity?mcId=${MCID}`);
    dispatch(setAllEntityList(data));
  };
  const fetchLatLongList = async () => {
    const { data } = await CALL_API("GET", `common/getLatLongLocation`);
    dispatch(setLatLongList(data));
  };
  const fetchUserLiat = async () => {
    const { data } = await CALL_API("GET", `user/getAll`);
    dispatch(setUserList(data));
  };
  const fetchSMSTemplateOptions = async () => {
    const { data } = await CALL_API("GET", "mastertable/msgtemplate", {});
    dispatch(setSmsTemplate(data));
  };
  const fetchUserPermissionList = async (MCID, UID) => {
    const { data } = await CALL_API(
      "POST",
      "role/getCurrentUserOrAdminPermission",
      {
        MCID: MCID,
        UID: UID,
      },
    );
    dispatch(setUserPermissionList(data));
  };

  const fetchMyPermissions = async () => {
    try {
      const { data } = await CALL_API("GET", `role/getMyPermissions`);

      // Normalize response (flatten nested arrays if present)
      let items = data ?? [];
      if (
        Array.isArray(items) &&
        items.length === 1 &&
        Array.isArray(items[0])
      ) {
        items = items[0];
      }
      if (Array.isArray(items) && items.some(Array.isArray))
        items = items.flat(1);

      const perms = (items || []).reduce((acc, item) => {
        const code = (item?.SECCODE || "").toUpperCase();
        const action = (item?.ACTION || "").toUpperCase();
        if (!code) return acc;
        if (!acc[code]) acc[code] = new Set();
        acc[code].add(action);
        return acc;
      }, {});

      const permObj = Object.keys(perms).reduce((acc, k) => {
        acc[k] = Array.from(perms[k]);
        return acc;
      }, {});

      dispatch(setMyPermissionList(permObj));
    } catch (err) {
      console.error("Error loading permissions:", err);
      dispatch(setMyPermissionList({}));
    }
  };
  const fetchAllCompany = async () => {
    const { data } = await CALL_API("GET", "container/getAllCompany", {});

    dispatch(setAICompanyList(data?.companies || []));
  };

  const fetchAllAIVehicle = async (ECTSCompId) => {
    try {
      const { data } = await CALL_API("GET", "container/getAllVehicle");

      const companyVehicles =
        data?.companies?.filter(
          (vehicle) => vehicle.FAgentGUID === ECTSCompId,
        ) || [];
      dispatch(setAIVehicleLists(companyVehicles));
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    }
  };

  const fetchAllFences = async (ECTSCompId) => {
    try {
      const { data } = await CALL_API("POST", "geoFence/getAllFenceList", {
        FAgentGUID: ECTSCompId,
      });
      dispatch(setFenceList(data));
    } catch (error) {
      console.error("[fetchAllFences] error:", error);
    }
  };

  const fetchAllNexusFences = async () => {
    try {
      const response = await fetch(
        "https://q7hxku4ta3.execute-api.ap-south-1.amazonaws.com/Prod/traking/allFence",
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );

      const companies = await response.json();

      dispatch(setNexusFenceList(companies.response || []));
    } catch (error) {
      console.error("[fetchAllNexusFences] error:", error);
    }
  };

  const fetchSubscriptionsMenu = async (MCID) => {
    if (MCID == null || MCID === "") return;
    try {
      const res = await CALL_API("GET", `subscription/getById?McID=${MCID}`);
      const rows = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
          ? res
          : [];
      const subscriptionSecCodes = rows
        .map((sub) => sub.SECCODE?.trim()?.toUpperCase())
        .filter(Boolean);

      dispatch(setSubscriptionList(subscriptionSecCodes));
    } catch (error) {
      console.error("[fetchSubscriptions] error:", error);
    }
  };

  const toggleLoggedIn = () => {
    const token = window.localStorage.getItem("token");
    if (!token) return;
    const tokenDetails = jwtDecode(token);
    setIsLoggedIn(true);
    dispatch(
      setUserInfo({
        email: tokenDetails?.EMAIL,
        firstName: tokenDetails?.FIRSTNM,
        lastName: tokenDetails?.LASTNM,
        MCID: tokenDetails?.MCID,
        ROLEID: tokenDetails?.ROLEID,
        UID: tokenDetails?.UID,
        WialonToken: tokenDetails?.WialonToken,
        ECTSCompId: tokenDetails?.ECTSCompId,
        NexusCompId: tokenDetails?.NexusCompId,
        COMPNAME: tokenDetails?.COMPNAME,
        SYSADM: tokenDetails?.SYSADM,
      }),
    );
    fetchConsigneeList(tokenDetails?.MCID);
    fetchTransporterList(tokenDetails?.MCID);
    fetchConsignerList(tokenDetails?.MCID);
    fetchAllVehicleList(tokenDetails?.MCID);
    fetchSupllierList(tokenDetails?.MCID);
    fetchRoleList(tokenDetails?.MCID);
    fetchOfficeList(tokenDetails?.MCID);
    fetchVehicleType();
    fetchCountryList();
    fetchLatLongList();
    fetchUserLiat();
    fetchSMSTemplateOptions();
    fetchDriverList(tokenDetails?.MCID);
    fetchKpiNameList(tokenDetails?.MCID);
    fetchAllEntityList(tokenDetails?.MCID);
    fetchRespientList(tokenDetails?.MCID);
    fetchDriverWithVehicle(tokenDetails?.MCID);
    fetchUserPermissionList(tokenDetails?.MCID, tokenDetails?.UID);
    fetchMyPermissions();
    fetchAllCompany();
    fetchAllAIVehicle(tokenDetails?.ECTSCompId);
    fetchAllFences(tokenDetails?.ECTSCompId);
    fetchAllNexusFences();
    fetchSubscriptionsMenu(tokenDetails?.MCID);
  };
  const redirectToNewDomain = () => {
    window.location.href = "https://www.uat.v2.trackright.africa/"; //wesite url
  };
  const publicRoutes = ["/tripTrack", "/TrackLinkAI", "/tracklink", "/nexusTrackLinkAI"];
  const urlParams = new URLSearchParams(window.location.search);
  var token = urlParams.get("token");
  const urlParts = window.location.pathname.split("/");
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    const token = urlParams.get("token") || window.localStorage.getItem("token");

    const currentPath = location.pathname;
    const isPublicRoute = publicRoutes.some((route) =>
      currentPath.startsWith(route),
    );
    if (token) {
      window?.localStorage?.removeItem("token");
      window.localStorage.setItem("token", token);
      sessionStorage.setItem("tokenTimestamp", new Date().getTime().toString());
      toggleLoggedIn();
      // navigate("/dashboard");
    }
    if (
      urlParts[1] === "tripTrack" ||
      urlParts[1] === "TrackLinkAI" ||
      urlParts[1] === "tracklink" ||
      urlParts[1] === "nexusTrackLinkAI"
    ) {
      toggleLoggedIn();
    }
    if (
      !token &&
      urlParts[1] !== "tripTrack" &&
      urlParts[1] !== "TrackLinkAI" &&
      urlParts[1] !== "tracklink" &&
      urlParts[1] !== "nexusTrackLinkAI"
    ) {
      redirectToNewDomain();
    }
  }, [location]);

  useEffect(() => {
    // Function to check token expiration
    const checkTokenExpiration = () => {
      const token = window.localStorage.getItem("token");
      const decodedToken = token ? jwtDecode(token) : null;
      if (!decodedToken || !decodedToken.exp) return;
      const currentTime = new Date().getTime();
      const expirationTime = decodedToken.exp * 1000 + 24 * 60 * 60 * 1000;
      if (
        currentTime > expirationTime &&
        urlParts[1] !== "tripTrack" &&
        urlParts[1] !== "TrackLinkAI" &&
        urlParts[1] !== "TrackLink" &&
        urlParts[1] !== "nexusTrackLinkAI"
      ) {
        setSessionTimeout(true);
        redirectToNewDomain();
      }
    };
    // Initial check
    checkTokenExpiration();
    // Set interval for periodic check
    const intervalId = setInterval(checkTokenExpiration, 60000); // Check every 1 minute
    // Cleanup on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const value = useSelector((state) => state?.authTracking?.selectedID);

  const timerRef = useRef(null);

  const logoutUser = () => {
    window.location.href = "https://www.uat.trackright.ai/";
  };

  const resetTimer = () => {
    clearTimeout(timerRef.current);

    timerRef.current = setTimeout(
      () => {
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          logoutUser();
        }, 5000);
      },
      30 * 60 * 1000,
    );
  };

  // const stayLoggedIn = () => {
  //   setOpen(false);
  //   resetTimer();
  // };

  const disableTimer =
    urlParts[1] === "TrackLinkAI" ||
    urlParts[1] === "tripTrack" ||
    urlParts[1] === "TripList1";

  useEffect(() => {
    if (disableTimer) return;
    console.log("Setting up inactivity timer", disableTimer);
    setOpen(false);
    resetTimer();

    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    return () => {
      clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []);

  return (
    <>
      <Modal
        open={open}
        footer={null}
        closable={false}
        centered
        zIndex={22222000}
        onCancel={""}
      >
        <h3>You are about to be logged out</h3>
        <p>No activity detected.</p>

        {/* <Button type="primary" onClick={stayLoggedIn}>
          Stay Logged In
        </Button>

        <Button danger onClick={logoutUser} style={{ marginLeft: 10 }}>
          Logout
        </Button> */}
      </Modal>

      <PopupProvider>
        <div>
          {(isLoggedIn ||
            publicRoutes.some((route) =>
              location.pathname.startsWith(route),
            )) && (
              <Routes>
                <Route path="/" element={<Mainindex />}>
                  {RoutesPath?.map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      element={<route.content />}
                    />
                  ))}
                </Route>
              </Routes>
            )}
          <DraggablePopup />
        </div>

        {/* <div style={{maxHeight: "0px"}} className="dummy">
          <LiveMapcomponent />
  </div> */}

        {/* <LiveMapcomponent /> */}
      </PopupProvider>
    </>
  );
}
export default App;
